/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { Menu, MenuGroup } from "types/models/menu"
import { CATALOGUE_DETAIL_PATTERN } from "constants/routes"
import {
  MenuState,
  MenuOverviewState,
  MenuDrawerState,
  MenuModalState,
} from "../menu.type"

// const initialMenu = (): Menu => mockMenu
export const initialMenu = (): Menu => ({
  sections: [],
  modifierGroups: [],
  isMenuEditorEnabled: true,
  sellingTimes: [],
  categories: [],
  departments: [],
  attributesData: {},
})

export const initialDrawer = (): MenuDrawerState => ({
  section: null,
  showSection: false,
  category: null,
  showCategory: false,
  item: null,
  showItem: false,
  showSortCategories: false,
  showSortDepartments: false,
  showSortSubDepartments: false,
  showSortItems: false,
  showItemSelection: false,
  showLinkModifierGroup: false,
  showMenuGroup: false,
  showMenuGroupLinkedStore: false,
  showMenuGroupLinkStore: false,
  showSellingTimeEditor: false,
  showMultiSelectSellingTime: false,
})

export const initialDrawerTrue = (): MenuDrawerState => ({
  section: null,
  showSection: false,
  category: null,
  showCategory: false,
  item: null,
  showItem: true,
  showSortCategories: false,
  showSortDepartments: false,
  showSortSubDepartments: false,
  showSortItems: false,
  showItemSelection: false,
  showLinkModifierGroup: false,
  showMenuGroup: false,
  showMenuGroupLinkedStore: false,
  showMenuGroupLinkStore: false,
  showSellingTimeEditor: false,
  showMultiSelectSellingTime: false,
})

export const initialModal = (): MenuModalState => ({
  showDeleteMenu: false,
})

export const initialOverview = (): MenuOverviewState => ({
  section: null,
  category: null,
  categories: [],
  items: [],
  department: null,
  departments: [],
  subDepartment: null,
  subDepartments: [],
  sellingTime: null,
})

export const initialMenuGroup = (): MenuGroup => ({
  menuGroupID: "",
  name: "",
  ownerType: null,
  ownerID: "",
  countryID: null,
  status: "",
  businessType: null,
  menuType: null,
  latestPropagateStatus: null,
  timeZone: "",
  createdAt: "",
  updatedAt: "",
  itemsWithoutPhotosCount: 0,
})

export const initialState = (): MenuState => ({
  itemFilter: "allItems",
  isItemPhotoCoverageBannerSkipped: false,
  categories: [],
  departments: [],
  subDepartments: [],
  menuGroups: [],
  menuGroupDetail: initialMenuGroup(),
  menuGroupServiceBasedMenuConfig: {},
  items: [],
  sellingTimes: [],
  menu: initialMenu(),
  merchantID: "",
  merchantGroupID: "",
  merchantIDs: [],
  overview: initialOverview(),
  drawer: initialDrawer(),
  modal: initialModal(),
  modifierGroupSearchKeyword: "",
  isFetchingMenu: false,
  isFetchingOutlets: false,
  isFetchingMoreOutlets: false,
  isFetchingMoreOutletsSearch: false,
  outletsSearchHasMore: false,
  isFetchingOutletsSearch: false,
  outletsHasMore: false,
  isFetchingCityList: false,
  outletsSearch: undefined,
  cityList: undefined,
  totalItemsWithoutPhoto: undefined,
  merchantBusinessTypeList: undefined,
  isFetchingMerchantBusinessTypeList: false,
  isEditAllowed: true,
  isStatusChangeAllowed: true,
  isCreateItemAllowed: true,
  isMartStore: CATALOGUE_DETAIL_PATTERN.test(window.location.pathname),
  isMartDepartmentStructure: false,
  brands: {
    isLoading: false,
  },
  isSellingTimeStructure: false,
  isMenuGroup: false,
  isUCS: false,
  isMenuGroupServiceBasedMenuEnabled: false,
  suggestedDepartments: [],
  enableAlcoholSetting: false,
  enableBcrsMenuGroupV2: false,
  isMenuGroupPage: false,
  enableMenuTranslationPortal: false,
  enablePartialMenu: false,
  isFetchingMerchantAggregate: false,
  merchantDeliverOptions: undefined,
  autoTranslationQueue: new Set(),
  originalTranslationFromDSMap: {},
  searchResults: undefined,
  searchItemLoading: false,
  searchQueryID: undefined,
  searchHighlightKey: undefined,
})
